import api from "./api";

const CustomerStoreService = {
  create: async (data) => {
    const res = await api.post("/customerStore/save", data);
    return res.data;
  },

  getAll: async (page = 1, limit = 20, search = "") => {
    const res = await api.get(
      `/customerStore/getAll?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`
    );
    return res.data;
  },

  getActive: async () => {
    const res = await api.get("/customerStore/getActive");
    return res.data;
  },

  getById: async (id) => {
    const res = await api.get(`/customerStore/getById/${id}`);
    return res.data;
  },

  update: async (id, data) => {
    const res = await api.put(`/customerStore/update/${id}`, data);
    return res.data;
  },

  delete: async (id) => {
    const res = await api.delete(`/customerStore/delete/${id}`);
    return res.data;
  },

  updateStatus: async (id) => {
    const res = await api.put(`/customerStore/updateStatus/${id}`);
    return res.data;
  },

  getByCustomer: async (customerId) => {
    const res = await api.get(`/customerStore/getByCustomer/${customerId}`);
    return res.data;
  },
};

export default CustomerStoreService;
